import { useState } from "react";
import { Building2, Briefcase, HardHat, AlertTriangle } from "lucide-react";
import { LOGIN_AS, LOGIN_AS_KEY } from "../lib/api";

const ICONS = { company: Building2, employer: Briefcase, contractor: HardHat };
const HINT = { company: "Company admin & staff", employer: "View your contractors", contractor: "Your workers & filings" };

export const LoginAsPicker = ({ children }) => {
  const [{ wrong, picked }] = useState(() => {
    const q = new URLSearchParams(window.location.search);
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem("c369-login-wrong") || "{}"); } catch { saved = {}; }
    return { wrong: q.get("wrong") || saved.wrong, picked: q.get("picked") || saved.picked };
  });
  const [as, setAs] = useState(localStorage.getItem(LOGIN_AS_KEY) || "");
  const pick = (k) => { setAs(k); localStorage.setItem(LOGIN_AS_KEY, k); if (k === wrong) sessionStorage.removeItem("c369-login-wrong"); };
  return (
    <div className="w-full max-w-[400px] grid gap-4" data-testid="login-as-picker">
      {wrong && LOGIN_AS[wrong] && (
        <div className="flex gap-2 rounded-lg border border-rose-500/40 bg-rose-500/10 p-3 text-sm text-rose-100" data-testid="login-as-mismatch">
          <AlertTriangle size={16} className="mt-0.5 shrink-0 text-rose-400" />
          <span>This is a <b>{LOGIN_AS[wrong].label}</b> account{picked && LOGIN_AS[picked] ? `, not ${LOGIN_AS[picked].label}` : ""}. Choose <b>{LOGIN_AS[wrong].label}</b> below and sign in again.</span>
        </div>)}
      <div>
        <div className="c-eyebrow mb-2">Sign in as</div>
        <div className="grid grid-cols-3 gap-2" role="radiogroup">
          {Object.entries(LOGIN_AS).map(([k, v]) => {
            const I = ICONS[k];
            return (
              <button key={k} type="button" role="radio" aria-checked={as === k} onClick={() => pick(k)} data-testid={`login-as-${k}`}
                className={`rounded-xl border p-3 text-left transition-colors ${as === k ? "border-[#00E599] bg-[#00E599]/10" : "border-[#1F2A3E] bg-[#121824] hover:border-slate-500"}`}>
                <I size={18} className={as === k ? "text-[#00E599]" : "text-slate-400"} />
                <div className="mt-2 text-sm font-semibold leading-tight">{v.label}</div>
                <div className="text-[11px] text-slate-500 mt-0.5 leading-tight">{HINT[k]}</div>
              </button>);
          })}
        </div>
      </div>
      {as ? <div data-testid="auth-form-container">{children}</div>
        : <p className="text-xs text-slate-500 text-center py-6 border border-dashed border-[#1F2A3E] rounded-xl" data-testid="login-as-prompt">Choose how you sign in to continue.</p>}
    </div>);
};
